<div class="d-flex justify-content-between">
  <div class="page-size mt-2">
    <span class="show-page">{{ 'BASE.SHOW_PAGE' | translate }}</span>
    <vss-ui-select-box [optionList]="sizeOptions" [csShowSearch]="false" [(ngModel)]="pageSize"
      (ngModelChange)="changePageSize($event)" [csAllowClear]="false"
      class="w-100 custom-page-size"></vss-ui-select-box>
  </div>

  <div class="page-size mt-2">
    <!-- <nz-pagination [nzPageIndex]="currentPage" [nzTotal]="100" [nzPageSize]="pageSize"
      [nzItemRender]="renderItemTemplate" 
      (nzPageSizeChange)="changePageSize($event)"
      [nzPageSizeOptions]="pageSizeOptions" (nzPageIndexChange)="changePageIndex($event)">
    </nz-pagination> -->

    <div class="custom-pagination">
      <button nz-button nzType="default" class="custom-next-btn" (click)="changePageIndex(1)"
        [disabled]="currentPage === 1">
        <i nz-icon [nzType]="'icons:start-btn-icon'" *ngIf="currentPage === 1"></i>
        <i nz-icon [nzType]="'icons:start-color-btn-icon'" style="transform: rotate(180deg);"
          *ngIf="currentPage !== 1"></i>
      </button>
      <button nz-button nzType="default" class="custom-next-btn" (click)="changePageIndex(currentPage - 1)"
        [disabled]="currentPage === 1">
        <i nz-icon [nzType]="'icons:prev-btn-icon'" *ngIf="currentPage === 1"></i>
        <i nz-icon [nzType]="'icons:prev-color-btn-icon'" style="transform: rotate(180deg);"
          *ngIf="currentPage !== 1"></i>
      </button>
      <span style="margin-right: 0.5rem;">Page</span>
      <input style="width: 4rem;" nz-input [(ngModel)]="currentPage" (blur)="changePageIndex(currentPage)" />
      <span style="margin-left: 0.5rem;"> of {{ totalPages }}</span>
      <button nz-button nzType="default" class="custom-next-btn" (click)="changePageIndex(currentPage + 1)"
        [disabled]="currentPage === totalPages">
        <i nz-icon style="transform: rotate(180deg);" [nzType]="'icons:prev-btn-icon'"
          *ngIf="currentPage === totalPages"></i>
        <i nz-icon [nzType]="'icons:prev-color-btn-icon'" *ngIf="currentPage !== totalPages"></i>
      </button>
      <button nz-button nzType="default" class="custom-next-btn" (click)="changePageIndex(totalPages)"
        [disabled]="currentPage === totalPages"><i nz-icon style="transform: rotate(180deg);"
          [nzType]="'icons:start-btn-icon'" *ngIf="currentPage === totalPages"></i>
        <i nz-icon [nzType]="'icons:start-color-btn-icon'" *ngIf="currentPage !== totalPages"></i>
      </button>
    </div>
    <!-- <ng-container *ngTemplateOutlet="renderItemTemplate; context: { type: 'page', page: 3 }"></ng-container> -->
  </div>

  <div class="page-size mt-2">
    {{'BASE.VIEW' | translate}} {{ startItem }}-{{ endItem }} {{'BASE.OF'
    | translate}} {{ totalItem }}
  </div>
</div>

<ng-template #renderItemTemplate let-type let-page="page">
  <ng-container [ngSwitch]="type">
    <a *ngSwitchCase="'page'">{{ page }}</a>
    <a *ngSwitchCase="'prev'"><i nz-icon nzType="left" nzTheme="outline" class="fs-sm" aria-hidden="true"></i></a>
    <a *ngSwitchCase="'next'"><i nz-icon nzType="right" nzTheme="outline" aria-hidden="true"></i></a>
    <a *ngSwitchCase="'prev_5'"><i nz-icon nzType="left" nzTheme="outline" class="prev" aria-hidden="true"></i> <span
        class="ant-pagination-item-ellipsis">•••</span></a>
    <a *ngSwitchCase="'next_5'"><i nz-icon nzType="right" nzTheme="outline" class="next" aria-hidden="true"></i><span
        class="ant-pagination-item-ellipsis">•••</span></a>
  </ng-container>
</ng-template>